import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBack = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.6667 15L6.66666 10L11.6667 5L12.8333 6.16667L8.99999 10L12.8333 13.8333L11.6667 15Z",
		fill: "currentColor"
	})
});
export default SvgBack;
